import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "./DeviceJsonDetails.scss";
import { BackArrow } from "../../../assets/icons-components/Icons";
import Buttons from "../../../components/Buttons/Buttons";
import Spinner from "../../../components/Spinner/Spinner";
import { GetDeviceById } from "../../../utils/apiCalls/devices";
import DeviceJsonSectionAccordion from "./DeviceJsonSectionAccordion";

const TAB_DEFS = [
  { key: "pcbTestLogs", label: "PCB Test Logs" },
  { key: "assemblyTestLogs", label: "Assembly Test Logs" },
  { key: "fftTestLogs", label: "FFT Test Logs" },
  { key: "shippingHistory", label: "Shipping History" },
  { key: "events", label: "Events" },
];

const DeviceJsonDetails = () => {
  const { deviceId } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [device, setDevice] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState("");

  const fetchDevice = () => {
    let ignore = false;
    setIsLoading(true);
    setFetchError("");
    GetDeviceById(deviceId)
      .then((res) => {
        if (ignore) return;
        if (res.statusCode === 200) {
          setDevice(res.data);
        } else {
          setFetchError(res.message || "Failed to load device");
        }
      })
      .catch((error) => {
        if (!ignore) setFetchError(error?.message || "Failed to load device");
      })
      .finally(() => {
        if (!ignore) setIsLoading(false);
      });
    return () => {
      ignore = true;
    };
  };

  useEffect(() => {
    return fetchDevice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceId]);

  const handleBack = () => navigate("/add-device");

  return (
    <div className="device-json-details">
      <div className="device-json-details_headers">
        <div className="device-json-details_headers_left">
          <div className="device-json-details_headers_left_arrow">
            <Buttons
              icon={<BackArrow />}
              ariaLabel="Back to Devices"
              onClick={handleBack}
              style={{ border: "none", padding: 0, backgroundColor: "transparent" }}
            />
            <div>
              <h3>{device?.deviceName || "Device"}</h3>
              <span className="device-json-details_udi">
                UDI: {device?.deviceUdi || "-"}
              </span>
              <br />
              <span className="device-json-details_udi">
                {device?.jsonVersion
                  ? `JSON v${device.jsonVersion} • ${device.jsonCreatedDate}`
                  : "No JSON uploaded yet"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
          <Spinner />
        </div>
      ) : fetchError ? (
        <p className="device-json-details_empty">
          {fetchError}{" "}
          <Buttons text="Retry" type="button" variant="smallsecondary" onClick={fetchDevice} />
        </p>
      ) : (
        <div style={{ padding: "0 12px" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", margin: "10px 0 20px 0" }}>
            <Tabs
              value={activeTab}
              onChange={(e, newValue) => setActiveTab(newValue)}
              aria-label="device json sections"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTabs-indicator": { backgroundColor: "#104581", height: "3px" },
                "& .MuiTab-root": {
                  fontWeight: 600,
                  fontSize: "14px",
                  textTransform: "none",
                  color: "#6b6a6a",
                  minWidth: "120px",
                },
                "& .MuiTab-root.Mui-selected": { color: "#104581" },
              }}
            >
              {TAB_DEFS.map((tab) => (
                <Tab key={tab.key} label={tab.label} />
              ))}
            </Tabs>
          </Box>

          {TAB_DEFS.map(
            (tab, index) =>
              activeTab === index && (
                <DeviceJsonSectionAccordion key={tab.key} section={device?.[tab.key]} />
              ),
          )}
        </div>
      )}
    </div>
  );
};

export default DeviceJsonDetails;
